import 'setimmediate';

/**
 * Call a function if its defined.
 *
 * @method call
 * @param  {Function} fn   The function to call, if defined. The scope is expected to be bound. Will be called with a null scope.
 * @param  {*[]}   args The arguments.
 * @return {*} What ever the callback returns.
 */
export function call(fn, ...args) {
  if (fn) {
    return fn.apply(null, args);
  }
}

/**
 * Call a function, debounced.
 *
 * @method debounced
 * @param  {Function} fn   The function to call, if defined. The scope is expected to be bound. Will be called with a null scope.
 * @param  {*[]}   args The arguments
 * @return {void}
 */
call.debounced = function debounced(fn, ...args) {
  const data = (debounced.data = debounced.data || new WeakMap());

  if (!fn) {
    return;
  }

  for (let arg of args) {
    // Find React's Pooled SyntheticEvents and persist them.
    if (arg && arg.persist && arg.preventDefault && arg.stopPropagation) {
      arg.persist();
    }
  }

  clearImmediate(data.get(fn));
  data.set(
    fn,
    setImmediate(() => fn.apply(null, args))
  );
};
